import React from 'react';

import {
    ButtonGroupIcon,
    IconLayoutTopPanel2,
    IconChartPie,
} from '@trqk/components';
import { locale, getSortablePeriodLabels } from '@trqk/utils';

import { useDashboard } from '../../../../../hooks';
import { StatementSelectorPreview } from '../../../../menus';

import './statements-header-content.css';

const buttonGroupOptions = [
    {
        Icon: IconChartPie,
        value: 'charts',
    },
    {
        Icon: IconLayoutTopPanel2,
        value: 'table',
    },
];

interface StatementsHeaderContentProps {
    displayMode: StatementsHeaderDisplayMode;
}

/**
 * Content for use in the LeftNavHeader for the StatementsPreview page. Differences from the
 * regular StatementsHeaderContent (i.e. non-Preview version):
 * - StatementSelectorPreview is used instead of StatementSelector
 * - ButtonGroupIcon is disabled
 * @param props {StatementsHeaderContentProps}
 */
export const StatementsPreviewHeaderContent = ({
    displayMode,
}: StatementsHeaderContentProps): JSX.Element => {
    const { dashboard } = useDashboard();

    const pro = dashboard?.statement_info?.pro ?? null;
    const end_date = dashboard?.statement_info?.period?.end_date ?? null;
    const start_date = dashboard?.statement_info?.period?.start_date ?? null;

    const periodLabels = getSortablePeriodLabels({
        start_date,
        end_date,
    });

    const dateLabel =
        periodLabels.short ||
        periodLabels.long ||
        `${start_date} to ${end_date}`;

    const statementSelectorLabel =
        pro !== null && start_date !== null && end_date !== null
            ? `${pro} ${dateLabel}`
            : locale.enUS.STATEMENTS.HEADER.FALLBACK_STATEMENT_LABEL;

    return (
        <div className="flex items-center">
            <h3 className="mr-6">{locale.enUS.STATEMENTS.TITLE}</h3>
            <StatementSelectorPreview label={statementSelectorLabel} />
            <div className="ml-8">
                <ButtonGroupIcon
                    disabled={true}
                    selectedValue={displayMode}
                    options={buttonGroupOptions}
                    handleChange={(): void => undefined}
                />
            </div>
        </div>
    );
};
